<template>
  <div class="confirm-employee-page">
    <div class="confirm-employee-logo-block gap-row-sm">
      <img src="/icons/qr-uikit-black-logo.svg" alt="" />
      <div class="qrw-label-sm bold v1-grey-6-color">Admin Panel</div>
    </div>
    <div class="confirm-employee-form-block">
      <div class="confirm-employee-form gap-row-lg">
        <div class="qrw-heading-md v1-grey-10-color">
          {{ $t("confirm_employee.title") }}
        </div>
        <div class="form-content gap-row-xs">
          <div class="qrw-label-sm bold v1-grey-6-color">
            {{ $t("confirm_employee.hint") }}
          </div>
          <BaseInput
            type="password"
            fullWidth
            :valid="!error"
            :placeholder="$t('confirm_employee.pass')"
            v-model="form.password"
          />
          <BaseInput
            type="password"
            :valid="!error"
            :placeholder="$t('confirm_employee.repeat')"
            fullWidth
            v-model="form.repeat"
          />

          <PasswordMeter
            :value="form.password"
            @score="(score) => (last_password_score = score)"
          />
        </div>
        <div class="red-4-color qrw-input-text" v-if="error">
          {{ error }}
        </div>
        <BaseDivider color="v1-grey-4" class="w-100" />
        <BaseButton
          :disabled="!form.password"
          @click="activate"
          class="w-100"
          variant="primary"
          bold
          color="green-6"
          size="md"
        >
          {{ $t("confirm_employee.btn") }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import EmployeesAPI from "@/api/employees";

import PasswordMeter from "@/components/PasswordMeter.vue";

export default {
  data() {
    return {
      form: {
        password: null,
        repeat: null,
      },

      last_password_score: 0,

      can_activate: false,

      error: null,

      busy: false,
    };
  },
  watch: {
    'form.password'() {
      this.error = null;
    },
    'form.repeat'() {
      this.error = null;
    }
  },
  methods: {
    checkActivation() {
      EmployeesAPI.canActivateEmployee(this.$route.params.id)
        .then((data) => {
          if (!data.can_activate) {
            window.location.href = "https://qrwaiter.com.ua/login";
          } else {
            this.can_activate = true;
          }
        })
        .catch((error) => {
          window.location.href = "https://qrwaiter.com.ua/login";
        });
    },
    activate() {
      this.error = null;

      if (this.last_password_score < 2) {
        this.error = this.$t("confirm_register.errors.weak");
        return;
      }

      if (!this.form.password || this.form.password != this.form.repeat) {
        this.error = this.$t("confirm_register.errors.mismatch");
        return;
      }

      this.busy = true;

      EmployeesAPI.activateEmployee(this.$route.params.id, this.form.password)
        .then((data) => {
          this.$store
            .dispatch("login", {
              email: data.email,
              password: this.form.password,
            })
            .then((ok) => {
              this.$store.commit("setMarketplaceEnabled", false);
              setTimeout(() => {
                this.$router.push("/");
                this.busy = false;
              }, 1500);
            })
            .catch((error) => {
              this.$router.push("/login");
            });

          // window.location.href = "https://qrwaiter.com.ua/login";
        })
        .catch((error) => {
          alert(error);
          this.busy = false;
        });
    },
  },
  mounted() {
    this.checkActivation();
  },
  components: {
    PasswordMeter,
  },
  computed: {
    isFormValid() {
      if (!this.form.password) return false;

      if (this.form.password != this.form.repeat) return false;

      if (this.last_password_score < 2) return false;

      if (this.busy) return false;

      return true;
    },
  },
};
</script>

<style scoped>
.confirm-employee-logo-block img {
  width: 32px;
  height: 32px;
  max-height: 32px;
  max-width: 32px;
  min-width: 32px;
  min-height: 32px;
}

.confirm-employee-logo-block {
  justify-content: center;
  width: 100%;
  align-items: center;
  padding-top: 80px;
}

.confirm-employee-form-block {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100%;
  width: 100%;
}

.confirm-employee-form {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;

  width: 320px;
  text-align: center;

  margin-top: calc(-80px - 152px);
}
</style>